<div>
  <div *ngIf="busy" style="display: block;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngIf="!linkedToStripeConnect && !busy">
    <div class="row margin-top-16">
      <div class="col-md-12 label">
        {{ "bikeshop.shop_profile.in_app_payments.not_connected_message" | translate }}
      </div>
    </div>
    <div class="stripe-connect-button">
      <img (click)="connectStripe()" src="../../../../../../../assets/stripe/stripe-connect-button.png">
    </div>
  </div>
  <div *ngIf="linkedToStripeConnect && !busy">
    <div class="row margin-top-16">
      <div class="col-md-12 label">
        {{ "bikeshop.shop_profile.in_app_payments.connected_message" | translate }}
      </div>
    </div>
    <div class="row margin-top-16">
      <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
        <button class="iso-round-button" type="submit"
                (click)="disconnectStripe()"
                [disabled]="busy">{{ 'bikeshop.shop_profile.in_app_payments.disconnect_from_stripe' | translate }}</button>
      </div>
    </div>
  </div>
  <div class="margin-top-16 label orange" *ngIf="linkedToStripeConnect && !busy && validPOSConnected">
    *{{ 'bikeshop.shop_profile.in_app_payments.payment_type_warning' | translate}}
  </div>
  <div class="row">
    <div class="col-md-12 powered_by_stripe">
      <img src="../../../../../../../assets/stripe/powered_by_stripe.png">
    </div>
  </div>
</div>
